var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.713,
    height: 10.628,
    viewBox: "0 0 5.713 10.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15858"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13842",
    d: "M5.612 5.572L4.535 3.86 5.162.54A.455.455 0 004.715 0H.995a.455.455 0 00-.447.54l.627 3.32-1.1 1.751a.455.455 0 00.385.7h1.944v3.861a.456.456 0 10.911 0V6.309h1.94a.455.455 0 00.354-.741zm-4.331-.169l.76-1.2a.455.455 0 00.062-.327L1.545.92h2.62l-.558 2.956a.455.455 0 00.062.327l.76 1.2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13859",
    d: "M1.073.565H4.65l-.6 3.279 1.254 2.143H.348l1.285-2.143z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinActive);
export default __webpack_public_path__ + "static/media/pin-active.67ea1d57bdd19be8ae5fe633f970d6cd.svg";
export { ForwardRef as ReactComponent };